<template>
  <b-modal ref="editWeightModal" title="Edit Weight" hide-footer @shown="show">
    <div>
      <form @submit.prevent="updateWeight" style="padding:15px;">
        <div class="form-group">
          <label for="weight">Weight*</label>
          <input
            :class="{
              'is-invalid': $v.weight.$invalid && submit,
              'is-valid': !$v.weight.$invalid && submit
            }"
            type="text"
            v-model="weight"
            class="form-control"
            id="weight"
            name="weight"
            aria-describedby="model_help"
            placeholder="i.e: 15.00"
          />
          <div class="invalid-feedback">Weight is required</div>
        </div>
        <b-btn variant="success" type="submit">Update</b-btn>
      </form>
    </div>
  </b-modal>
</template>

<script>
import { required, decimal } from "vuelidate/lib/validators";
export default {
  name: "edit-weight-modal",
  data() {
    return {
      filesList: null,
      weight: null,
      orderId: null,
      submit: false
    };
  },
  validations() {
    return {
      weight: {
        required,
        decimal
      }
    };
  },
  props: ["editOrder"],
  methods: {
    updateWeight() {
      this.submit = true;
      if (!this.$v.$invalid) {
        //show loader
        let loader = this.$loading.show();
        this.$http
          .post(this.APIURL + this.BRAND + "/dispatch/update-weight", {
            weight: this.weight,
            "order-id": this.orderId
          })
          .then(
            () => {
              this.hideModal();
              loader.hide();
              this.$emit("weightUpdated");
            },
            error => {
              console.log(error);
            }
          );
      }
    },
    show() {
      this.weight = parseFloat(this.editOrder.weight).toFixed(2);
      this.orderId = this.editOrder.order_id;
    },
    showModal() {
      this.$refs.editWeightModal.show();
    },
    hideModal() {
      this.$refs.editWeightModal.hide();
    }
  }
};
</script>
